import IdeasView from './IdeasView';
import './IdeasView.scss';

export default IdeasView;
